import { render, staticRenderFns } from "./autInformation.vue?vue&type=template&id=631778a6&scoped=true"
import script from "./autInformation.vue?vue&type=script&lang=js"
export * from "./autInformation.vue?vue&type=script&lang=js"
import style0 from "./autInformation.vue?vue&type=style&index=0&id=631778a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631778a6",
  null
  
)

export default component.exports